import { LangLocale } from '@myre/common-i18n';
import { type Scope } from '@myre/domain-i18n-core';

import { InjectionToken } from '@angular/core';

export const LANGLOCALE = new InjectionToken<LangLocale>('LangLocale');
export const MYRE_I18N_SCOPE = new InjectionToken<Scope>('I18nScope');
